module.exports = __webpack_public_path__ + "static/media/manufacturing.e68990fc.png";